import React, { useState } from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

// Champ SIRET contrôlé (facturation électronique) : saisie + vérification annuaire.
// L'enregistrement est porté par le bouton « Enregistrer » du formulaire parent.
export default function SiretField({ value, onChange }) {
  const [company, setCompany] = useState(null);
  const [looking, setLooking] = useState(false);
  const [error, setError] = useState(null);

  async function lookup() {
    const digits = (value || '').replace(/\D/g, '');
    if (digits.length !== 9 && digits.length !== 14) {
      setError('SIRET invalide : saisissez 14 chiffres (ou 9 pour le SIREN).');
      return;
    }
    const siren = digits.slice(0, 9);
    setLooking(true);
    setError(null);
    setCompany(null);
    try {
      const r = await fetch(`https://recherche-entreprises.api.gouv.fr/search?q=${siren}&page=1&per_page=1`);
      const j = await r.json();
      const c = j && j.results && j.results[0];
      if (!c) {
        setError('SIREN introuvable dans le registre des entreprises.');
        return;
      }
      const siege = c.siege || {};
      setCompany({
        name: c.nom_complet || c.nom_raison_sociale || '',
        address: [siege.adresse, [siege.code_postal, siege.libelle_commune].filter(Boolean).join(' ')]
          .filter(Boolean)
          .join(', '),
      });
    } catch (e) {
      setError('Recherche impossible pour le moment.');
    } finally {
      setLooking(false);
    }
  }

  return (
    <Box padding={2} display="flex" flexDirection="column" alignItems="center">
      <Box width="100%" maxWidth={600} component={Paper} variant="outlined" padding={4}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>Facturation électronique</Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Renseignez le SIRET de votre structure (requis pour l'émission de vos factures conformes).
          Il sera enregistré avec le reste de votre profil.
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm>
            <TextField
              label="SIRET"
              value={value || ''}
              onChange={(e) => { onChange(e.target.value); setCompany(null); }}
              inputProps={{ inputMode: 'numeric' }}
              fullWidth
            />
          </Grid>
          <Grid item>
            <Button onClick={lookup} disabled={looking}>
              {looking ? <CircularProgress size={20} /> : 'Vérifier'}
            </Button>
          </Grid>
        </Grid>
        {error && <Typography color="error" variant="body2" style={{ marginTop: 8 }}>{error}</Typography>}
        {company && (
          <Paper variant="outlined" style={{ marginTop: 12, padding: 12 }}>
            <Typography variant="body2" color="textPrimary" style={{ fontWeight: 600 }}>{company.name}</Typography>
            {company.address && (
              <Typography variant="body2" color="textSecondary">{company.address}</Typography>
            )}
          </Paper>
        )}
      </Box>
    </Box>
  );
}
